import "./component-library117.mjs";
import normalizeComponent from "./component-library81.mjs";
const _sfc_main = {
  name: "GridRow",
  props: {
    alignH: {
      type: String,
      default: "start",
      validator(value) {
        return ["center", "end", "start", "space-between", "space-between"].includes(value);
      }
    },
    alignV: {
      type: String,
      default: null,
      validator(value) {
        return ["", "center", "end", "start"].includes(value);
      }
    },
    noGutter: { type: Boolean },
    clearPadding: { type: Boolean }
  },
  computed: {
    classes() {
      const modifier = [];
      if (this.alignH)
        modifier.push(`grid-row--h-${this.alignH}`);
      if (this.alignV)
        modifier.push(`grid-row--v-${this.alignV}`);
      if (this.noGutter)
        modifier.push("grid-row--no-gutter");
      if (this.clearPadding)
        modifier.push("grid-row--clear-padding");
      return modifier;
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { staticClass: "grid-row", class: _vm.classes }, [_vm._t("default")], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "8b658b15",
  null,
  null
);
const GridRow = __component__.exports;
export {
  GridRow as default
};
